// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import BootstrapVue from 'bootstrap-vue'
import BackToTop from 'vue-backtotop'
import VueAnalytics from 'vue-analytics'
import Ads from 'vue-google-adsense'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueAnalytics, {id: 'UA-75265892-2', router})
Vue.use(require('vue-script2'))

Vue.use(BootstrapVue)
Vue.use(BackToTop)
Vue.use(Ads.Adsense)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js